import { render, staticRenderFns } from "./LpInformations.vue?vue&type=template&id=2371b6ac"
import script from "./LpInformations.vue?vue&type=script&lang=js"
export * from "./LpInformations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports